import React from 'react';
import { cn } from 'lib/utils';
import { Label } from 'components/ui/label';

export interface IRadioConfig {
  detailsElement: JSX.Element;
  value: string;
  onChangeHandler: (arg: string) => void;
  selected: boolean;
  label?: string;
  icon?: JSX.Element;
}

const RadioButtonCard = ({
  config,
  name,
  cardStyles,
}: {
  config: IRadioConfig;
  name: string;
  cardStyles?: Record<string, string>;
}) => (
  <Label
    htmlFor={config.value}
    className={cn(
      'card-radio-input flex w-56 h-16 py-3 pr-3 pl-4 cursor-pointer rounded-sm',
      config.selected
        ? 'border border-green-400 ring-4 ring-green-100'
        : 'shadow-card-hover'
    )}
    style={cardStyles}
    onClick={() => config.onChangeHandler(config.value)}
  >
    <div className="grow">
      {config?.icon}
      <span>{config.detailsElement}</span>
    </div>
    <div>
      <input
        type="radio"
        name={name}
        id={config.value}
        value={config.value}
        className="absolute -ml-5 mt-[0.3rem] mb-0"
        onChange={(e) => config.onChangeHandler(e.target.value)}
        checked={config.selected}
        aria-label={config.label}
      />
    </div>
  </Label>
);

export default RadioButtonCard;
